/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConflict = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4.049 10.463-1.966-1.966-4 5-2.034-2.034-2.661 3.04A8 8 0 0 0 19.305 8.74zM12 4a8 8 0 0 0-7.577 10.568l3.528-4.03 1.965 1.964 4.001-5 2.034 2.035 2.257-2.58A7.983 7.983 0 0 0 12 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgConflict as Conflict };
